import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import InferenceResults from '../../../../pages/inferenceResults/InferenceResults';
import { VIEW_INFERENCE_RESULTS_PAGE } from '../../../../utils/permissions';

const searchSchema = z.object({
  sampleSetId: z.string().optional(),
  sampleSetName: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_navbar/results/$jobId')({
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(VIEW_INFERENCE_RESULTS_PAGE)) {
      throw notFound();
    }
  },
  component: InferenceResults,
});
